import { RestrictionTier } from "@redotech/cockroachdb-codegen/tables/xborder-outbound/restriction-tier";
import * as z from "zod";

export const restrictionTier = z.enum(RestrictionTier);
